<template>
  <a-modal
    title="缺考登记"
    :width="600"
    :maskClosable="false"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="visible = false"
  >
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="原因">
        <a-textarea
          v-decorator="['reason', validatorRules.reason]"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="证明材料">
        <j-upload
          v-decorator="['reasonFile', validatorRules.reasonFile]"
          :uploadTarget="'qiniu'"
          :fileType="'image'"
          :number="1"
          :minFileSize="100"
          :maxFileSize="2"
          :trigger-change="true"
        ></j-upload>
        <div v-if="eventInfo.missingApplyTemplate">
            <p>
            下载承诺书范本，打印后签名保存为jpg格式在此上传，图片限制2MB以内。
          </p>
          <a :href="eventInfo.missingApplyTemplate_url" target="_blank"
            ><a-icon type="cloud-download" /> 范本下载</a
          >
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { getAction, postAction } from "@/api/manage";
import JUpload from "@/components/jeecg/JUpload";
import pick from "lodash.pick";
export default {
  name: "MissingExamApplyModal",
  components: {
    JUpload,
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      myEvent: {},
      eventInfo: {},
      validatorRules: {
        reason: {
          rules: [{ required: true, message: "请输入原因!" }],
        },
        reasonFile: {
          rules: [
            { required: true, message: "请上传承诺书! 100KB-1MB的JPG图片" },
          ],
        },
      },
    };
  },
  created() {},
  methods: {
    open(myEvent) {
      this.visible = true;
      this.form.resetFields()
      this.myEvent = myEvent
      this.getEventInfo(myEvent.eventId)
    },
    getEventInfo(eventId) {
      this.confirmLoading = true;
      getAction('/teaching/teachingEvent/queryById', { id: eventId }).then((res) => {
        if (res.success) {
          this.eventInfo = res.result
          this.confirmLoading = false
        } else {
          this.$message.warning("活动不存在");
        }
      })
    },
    handleOk() {
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          values.eventId = that.myEvent.eventId;
          values.eventApplyId = that.myEvent.eventApplyId
          postAction("/teaching/teachingMissingExamApply/missingApply", values)
            .then((res) => {
              if (res.success) {
                that.visible = false;
                that.$success({
                  title: "提交成功",
                  content: (
                    <div>
                      <p>缺考登记已提交，请耐心等待审核</p>
                    </div>
                  ),
                });
                that.$emit("ok");
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>